import role from '@/auth/role'

export default [
  {
    path: '/organization/settings/account/:tab?',
    name: 'organization-settings-account',
    component: () => import('@/views/organization/settings/account/AccountSettings.vue'),
    meta: {
      title: 'navigation.settings.account-settings',
      access: [role.admin],
      pageTitle: 'navigation.settings.account-settings',
      breadcrumb: [
        {
          text: 'navigation.settings.company-profile',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/settings/plan-and-billing',
    name: 'organization-settings-plan-and-billing',
    component: () => import('@/views/organization/settings/plan-and-billing/PlanAndBilling.vue'),
    meta: {
      title: 'navigation.settings.plan-and-billing',
      access: [role.admin],
      pageTitle: 'navigation.account-settings',
      breadcrumb: [
        {
          text: 'navigation.settings.plan-and-billing',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/settings/educators',
    name: 'organization-settings-educators-list',
    component: () => import('@/views/organization/settings/educators/List.vue'),
    meta: {
      title: 'navigation.settings.educators',
      access: [role.admin],
      pageTitle: 'navigation.settings.educators',
      breadcrumb: [
        {
          text: 'navigation.settings.educators',
          active: true,
        },
      ],
    },
  },
  {
    path: '/organization/settings/educators/view/:id',
    name: 'organization-settings-educator-view',
    component: () => import('@/views/organization/settings/educators/View/View.vue'),
    meta: {
      title: 'navigation.settings.educators',
      access: [role.admin],
      pageTitle: 'navigation.settings.educator',
      breadcrumb: [
        {
          text: 'navigation.settings.educators',
          to: { name: 'organization-settings-educators-list' },
        },
        {
          text: 'navigation.settings.educator',
          active: true,
        },
      ],
    },
  },
]
